import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const location = useLocation();
  
  const navItems = [
    { path: '/', label: 'Dashboard', icon: '📊', color: 'blue' },
    { path: '/campaigns', label: 'Campagnes', icon: '📢', color: 'green' },
    { path: '/script', label: 'Scripts', icon: '📝', color: 'purple' },
    { path: '/calls', label: 'Appels', icon: '📞', color: 'red' },
    { path: '/conversations', label: 'Conversations', icon: '💬', color: 'indigo' },
    { path: '/analytics', label: 'Analytics', icon: '📈', color: 'yellow' },
    { path: '/voices', label: 'Voix IA', icon: '🎙️', color: 'pink' },
    { path: '/asterisk-config', label: 'Config Asterisk', icon: '⚙️', color: 'orange' },
    { path: '/settings', label: 'Paramètres', icon: '🔧', color: 'gray' }
  ];

  return (
    <div className="fixed inset-y-0 left-0 z-50 w-64 bg-gradient-to-b from-blue-900 via-blue-800 to-blue-900 transform transition-transform duration-300 ease-in-out">
      {/* Logo Section */}
      <div className="flex items-center justify-center h-20 bg-blue-950 border-b border-blue-700">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 rounded-xl overflow-hidden">
            <img 
              src="/assets/voxipro-logo.png" 
              alt="VoxiPro AI" 
              className="w-full h-full object-cover"
            />
          </div>
          <div className="text-white">
            <h1 className="text-xl font-bold">VoxiPro AI</h1>
            <p className="text-xs text-blue-200">Automatisation Vocale</p>
          </div>
        </div>
      </div>

      {/* Navigation Items */}
      <nav className="mt-8">
        <div className="px-4 space-y-2">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-200 ${
                location.pathname === item.path
                  ? 'bg-blue-600 text-white shadow-lg'
                  : 'text-blue-100 hover:bg-blue-700 hover:text-white'
              }`}
            >
              <span className="text-xl mr-3">{item.icon}</span>
              {item.label}
            </Link>
          ))}
        </div>
      </nav>
      
      {/* VoxiPro AI Logo Section */}
      <div className="px-4 mt-6 mb-4">
        <div className="bg-gradient-to-r from-blue-700 to-blue-600 rounded-lg p-4 text-center">
          <div className="w-16 h-16 mx-auto mb-2 bg-white bg-opacity-20 rounded-full flex items-center justify-center overflow-hidden">
            <img 
              src="/voxipro_logo_detoure.png" 
              alt="VoxiPro AI" 
              className="w-12 h-12 object-contain"
            />
          </div>
          <div className="text-white text-sm font-medium">VoxiPro AI</div>
          <div className="text-blue-200 text-xs">Powered by Asterisk</div>
        </div>
      </div>
      
      {/* Bottom Status */}
      <div className="absolute bottom-0 w-full p-4">
        <div className="bg-blue-800 rounded-lg p-3">
          <div className="flex items-center justify-between text-sm">
            <span className="text-blue-200">Status IA</span>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
              <span className="text-green-400 text-xs">Opérationnel</span>
            </div>
          </div>
          <div className="mt-2 text-xs text-blue-300">
            Pipeline: STT→LLM→TTS
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;